var ChartDateIntervalSelectorModule = /** @class */ (function () {
    function ChartDateIntervalSelectorModule() {
    }
    return ChartDateIntervalSelectorModule;
}());
export { ChartDateIntervalSelectorModule };
